var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "form",
    {
      ref: "configForm",
      staticClass: "default",
      attrs: {
        action: _vm.actionUrl,
        method: "post",
      },
    },
    [
      _c("fieldset", [
        _c("legend", [_c("translate", [_vm._v("Cachetyp")])], 1),
        _vm._v(" "),
        _c(
          "label",
          [
            _c("translate", [_vm._v("Cachetyp auswählen")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedCacheType,
                    expression: "selectedCacheType",
                  },
                ],
                attrs: {
                  name: "cachetype",
                },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedCacheType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.getCacheConfig,
                  ],
                },
              },
              _vm._l(_vm.cacheTypes, function (type) {
                return _c(
                  "option",
                  {
                    key: type.cache_id,
                    domProps: {
                      value: type.class_name,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(type.display_name) +
                        "\n                "
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "fieldset",
        [
          _c("legend", [_vm._v("Konfiguration")]),
          _vm._v(" "),
          _vm.configComponent != null
            ? [
                _c(
                  _vm.configComponent,
                  _vm._b(
                    {
                      ref: "cacheConfig",
                      tag: "component",
                      on: {
                        "is-valid": _vm.setValid,
                      },
                    },
                    "component",
                    _vm.configProps,
                    false
                  )
                ),
              ]
            : [
                _c("translate", [
                  _vm._v(
                    "Für diesen Cachetyp ist keine Konfiguration erforderlich."
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "footer",
        {
          attrs: {
            "data-dialog-button": "",
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "button accept",
              attrs: {
                disabled: !_vm.isValid,
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.validateConfig.apply(null, arguments)
                },
              },
            },
            [_c("translate", [_vm._v("Speichern")])],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }